var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wp-content"},[_vm._l((_vm.layouts),function(layout,index){return _c('BaseLayout',{key:index,attrs:{"layoutData":layout}})}),_c('vue-headful',{attrs:{"title":_vm.pageTitle,"description":_vm.pageDescription,"keywords":_vm.pageKeywords}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }